<portal-progress-button
  [btnClass]="btnClass"
  [disabled]="disabled"
  [hyperlink]="hyperlink"
  [isNgbDropdownItem]="isNgbDropdownItem"
  [progress]="progress"
  [progressText]="progressText"
  (clicked)="download()"
  ><ng-content></ng-content
></portal-progress-button>
